export default {
  items: {},
  facets: {},
};
